// src/lib/audit.js
import { callFunction } from './edge';
import { supabase } from 'services/supabaseClient';

/**
 * Write an audit log entry to Supabase Edge Function "audit-log".
 * Ensures actor_user_id is always set if the user is signed in.
 *
 * @param {object} payload - Must include category, action.
 *  - category: string ("auth", "user", "access", "upload", "export")
 *  - action: string ("login_success", "user_deleted", "app_access_granted", etc.)
 *  - success?: boolean
 *  - severity?: "info" | "warn" | "error"
 *  - target_user_id?: string
 *  - detail?: object
 */
export async function logAudit(payload) {
  try {
    // Get current session
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;

    // Try to resolve actor_user_id directly
    let actorId = payload.actor_user_id ?? null;
    if (!actorId) {
      const { data: { user }, error } = await supabase.auth.getUser();
      if (!error && user?.id) {
        actorId = user.id;
      }
    }

    // Normalize detail
    let detail = payload.detail;
    if (detail && typeof detail !== 'object') {
      console.warn('[audit] detail was not an object, coercing to string');
      detail = { raw: String(detail) };
    }

    // Build safe body
    const body = {
      category: payload.category,
      action: payload.action,
      success: typeof payload.success === 'boolean' ? payload.success : null,
      severity: payload.severity ?? undefined,
      actor_user_id: actorId,
      target_user_id: payload.target_user_id ?? null,
      session_id: payload.session_id ?? null,
      correlation_id: payload.correlation_id ?? null,
      app: payload.app ?? 'portal',
      detail: detail ?? {}, // always an object
    };

    await callFunction('audit-log', {
      body,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  } catch (err) {
    console.error('[audit] logAudit error:', err);
  }
}
